
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 17 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 0c2.254 0 4.416.961 6.01 2.672 1.595 1.71 2.49 4.03 2.49 6.45C17 16.098 11.5 22 8.5 22S0 16.098 0 9.122c0-2.42.896-4.74 2.49-6.45C4.084.962 6.246 0 8.5 0zM14 10.732a4.24 4.24 0 00-1.831.418 4.53 4.53 0 00-1.515 1.181 4.925 4.925 0 00-.935 1.741 5.164 5.164 0 00-.194 1.999 4.24 4.24 0 002.306-.391 4.53 4.53 0 001.515-1.182c.422-.504.74-1.097.935-1.74.194-.645.26-1.326.194-2a4.684 4.684 0 00-.475-.026zm-11 0c-.16 0-.318.009-.475.027a5.16 5.16 0 00.232 2.12 4.89 4.89 0 001.06 1.804c.475.51 1.05.899 1.683 1.139s1.308.325 1.975.249c.017-.168.025-.338.025-.51 0-1.28-.474-2.51-1.318-3.415-.844-.905-1.989-1.414-3.182-1.414z","fill":"#F8BF1E"}})])
          )
        }
      }
    